import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiPackage, FiShoppingBag, FiUsers, FiRefreshCw, FiDollarSign } from 'react-icons/fi';
import { getAdminStats } from '../../services/api';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAdminStats().then(res => setStats(res.data)).finally(() => setLoading(false));
  }, []);

  const cards = stats ? [
    { icon: FiDollarSign, label: 'Total Revenue',    value: `৳${stats.totalRevenue.toLocaleString()}`, color: 'bg-green-50 text-green-600',  link: '/admin/orders' },
    { icon: FiPackage,    label: 'Total Orders',     value: stats.totalOrders,     color: 'bg-blue-50 text-blue-600',   link: '/admin/orders' },
    { icon: FiShoppingBag,label: 'Products',         value: stats.totalProducts,   color: 'bg-purple-50 text-purple-600',link: '/admin/products' },
    { icon: FiUsers,      label: 'Customers',        value: stats.totalUsers,      color: 'bg-amber-50 text-amber-600', link: '#' },
    { icon: FiRefreshCw,  label: 'Pending Returns',  value: stats.pendingReturns,  color: 'bg-red-50 text-red-600',    link: '/admin/returns' },
  ] : [];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      {/* Header */}
      <div className="flex items-center justify-between mb-10">
        <div>
          <h1 className="font-display text-4xl font-bold text-yamass-black">Admin Dashboard</h1>
          <p className="text-gray-400 text-sm mt-1">YAMASS store management</p>
        </div>
        <div className="flex gap-3">
          <Link to="/admin/products" className="bg-yamass-black text-white text-sm px-5 py-2.5 rounded-full hover:bg-yamass-accent transition-colors">
            + Add Product
          </Link>
        </div>
      </div>

      {/* Stat cards */}
      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-10">
          {[...Array(5)].map((_, i) => <div key={i} className="skeleton h-28 rounded-2xl" />)}
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-10">
          {cards.map(({ icon: Icon, label, value, color, link }) => (
            <Link key={label} to={link} className="bg-yamass-cream rounded-2xl p-5 hover:shadow-md transition-shadow">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center mb-3 ${color}`}>
                <Icon size={18} />
              </div>
              <p className="text-2xl font-bold text-yamass-black">{value}</p>
              <p className="text-xs text-gray-400 mt-1">{label}</p>
            </Link>
          ))}
        </div>
      )}

      {/* Quick nav */}
      <div className="grid md:grid-cols-3 gap-5">
        {[
          { title: 'Manage Products',  desc: 'Add, edit, delete products',     link: '/admin/products', emoji: '👕' },
          { title: 'Manage Orders',    desc: 'Update order status & tracking',  link: '/admin/orders',   emoji: '📦' },
          { title: 'Handle Returns',   desc: 'Review and process return requests', link: '/admin/returns', emoji: '🔄' },
        ].map(item => (
          <Link key={item.link} to={item.link} className="bg-yamass-cream rounded-2xl p-6 hover:shadow-md transition-shadow group">
            <div className="text-4xl mb-3">{item.emoji}</div>
            <h3 className="font-semibold text-yamass-black group-hover:text-yamass-accent transition-colors">{item.title}</h3>
            <p className="text-sm text-gray-400 mt-1">{item.desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
